<template>
  <div class="my-12 text-center" v-if="isShare">
    <span class="text-14 text-text">
      HELP SPREAD THE WORD TO MAKE A GREATER IMPACT!
    </span>
    <button
      class="w-full rounded-md py-2 mt-5 bg-friend uppercase text-white"
      @click="share"
    >
      Invite a Friend
    </button>
  </div>
</template>
<script>
export default {
  computed: {
    isShare() {
      return navigator.share;
    }
  },
  methods: {
    async share() {
      try {
        await navigator.share({
          text:
            "Hey, this is pretty cool and I thought you'd want to know about it. You should try THRIVE | Initiative's new Change4Good platform. It lets you donate your spare change from everyday transactions to a vetted and local beneficiary, plus you get some pretty sweet discounts from neighborhood shops and restaurants. Check it out!",
          url: "https://app.jointhriveinitiative.org/"
        });
      } catch (error) {
        console.log("Sharing failed!", error);
      }
    }
  }
};
</script>
<style lang="scss" scoped>
.bg-friend {
  background-color: var(--share-btn-color);
}
</style>
